import React, { FC } from 'react';
import { Box, List } from '@mui/material';
import { MobileNavigationItem } from './MobileNavigationItem';
import { MobileMenuItemsProps } from '../../../../models/NavigationMenuItem';

export const MobileNavigationItemWrapper: FC<MobileMenuItemsProps> = (
    props
) => {
    const menuItems = props.menuItems;

    return (
        <Box sx={{ width: 250 }} role="presentation">
            <List>
                {menuItems && menuItems.title && (
                    <MobileNavigationItem
                        menuItem={menuItems}
                        clickHandler={props.clickHandler}
                        isParent={true}
                    />
                )}
                {menuItems &&
                    menuItems.items.map((item) => (
                        <MobileNavigationItem
                            key={item.id}
                            menuItem={item}
                            clickHandler={props.clickHandler}
                            isParent={false}
                        />
                    ))}
            </List>
        </Box>
    );
};
